import DonationHistory from "../DonorManagement/DonationHistory";
import { Helmet } from "react-helmet";
function DonationReport(){
    return ( 
        <>
                <Helmet>
                    <title>DonorX | Donation Reports</title>
                </Helmet>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Donation Reports</h2>

                    <div className={`el-profile-board   el-bg-table mb-5`}>
                        <DonationHistory userType={"donation_report"} />
                    </div>
                </div>
        </>
    ); 
}
    
    export default DonationReport;